import React from 'react';
// Components
import PlaySectionOne from './PlaySectionOne';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import CallToActionOne from '../cta/CallToActionOne';
import PlaySectionTwo from './PlaySectionTwo';
import {
  CompanyTagLine,
  MainTitle,
  SubtitleMain,
} from '../../utils/Constants';
import TestimonialSection from '../testimonials/TestimonialSection';
import { CONTACT_PAGE_URL } from '../../utils/Routes';

function HomePageMainContainer() {
  return (
    <main
      role='main'
      className='grid pt-[300px] sm:pt-[320px] lg:pt-[60vh] gap-y-12 lg:gap-y-16 w-full h-full bg-colour1 dark:bg-colour1 full_shadow_black_invert pb-16'
    >
      {/* Header mobile */}
      <div className='grid px-4 sm:px-16 md:px-20 mt-8 sm:mt-10'>
        <article
          className='grid lg:hidden bg-black/40 curved_box p-1.5 rounded-lg'
          aria-labelledby='header-title'
        >
          <div className='grid p-0.5 rounded-lg bg-colour3 curved_box'>
            <div className='grid bg-colour2 rounded-lg curved_box'>
              <div className='grid relative font-titleFont px-4 py-12 leading-4 bg-colour2 gap-2 lg:gap-1 text-center text-colour5'>
                <h2 className='text-lg font-semibold'>{MainTitle}</h2>
                <h3 className='py-2'>{SubtitleMain}</h3>
                <h4 className='py-2'>{CompanyTagLine}</h4>
                <div className='grid mt-2 px-4'>
                  <a
                    href={CONTACT_PAGE_URL}
                    title='Request a session now'
                    className='border-2 cursor-pointer border-solid py-2 px-6 rounded border-colour3 text-colour1 bg-colour4/80 duration-300 hover:bg-red-700 md:max-w-fit md:px-10 md:mx-auto'
                    aria-label='Request a session now'
                  >
                    <span className='uppercase font-bold'>Submit to Me</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>

      {/* First section */}
      <div className=''>
        <PlaySectionOne />
      </div>

      {/* Gallery */}
      <div className='grid w-full h-full bg-colour3 py-6 lg:py-10 lg:px-10 full_shadow_black_invert'>
        <SmallGalleryComponent />
      </div>

      <div className=''>
        <PlaySectionTwo />
      </div>

      <div>
        <CallToActionOne />
      </div>

      <div>
        <TestimonialSection />
      </div>
    </main>
  );
}

export default HomePageMainContainer;
